<!-- Answers: which weekdays are busiest (bookings + players) in the selected timeline. -->
<template>
    <section class="panel">
        <h2>Most popular days</h2>
        <p class="panel-subtitle">Based on selected timeline: {{ selectedRangeLabel }}</p>
        <dashboard-bar-chart-host
            wrap-class="compact"
            :labels="dayLabels"
            :datasets="dayDatasets"
            :extra-options="popularBarChartOptions"
        />
    </section>
</template>

<script setup>
import DashboardBarChartHost from "./DashboardBarChartHost.vue";

const props = defineProps({
    selectedRangeLabel: { type: String, required: true },
    dayLabels: { type: Array, default: () => [] },
    dayDatasets: { type: Array, default: () => [] },
});

/** No fixed y stepSize=1 — player totals can exceed booking counts (co-located with these charts). */
const popularBarChartOptions = {
    scales: {
        y: {
            ticks: { maxTicksLimit: 12 },
        },
    },
};
</script>

<style scoped lang="scss">
@use "../../colors" as *;

.panel {
    box-sizing: border-box;
    margin-top: 1rem;
    min-width: 0;
    width: 100%;
    padding: 1rem 1.25rem 1.25rem;
    border: 1px solid $color-primary;
    border-radius: 0.5rem;
    background: rgba($color-background, 0.71);

    h2 {
        margin: 0 0 0.35rem;
        font-size: 1.1rem;
        color: $color-primary;
        font-weight: 600;
    }
}

.panel-subtitle {
    margin: 0 0 0.9rem;
    color: $color-text-primary;
    font-size: 0.9rem;
}
</style>
